import React from 'react';

class Logo extends React.Component {
  render() {
    return (
      <a className="u-fill-height" href="https://cashnote.kr/">
        <img style={{ width: '80px' }} src="logo.png" alt="Logo" />
      </a>
    );
  }
}

export default Logo;



// WEBPACK FOOTER //
// ./src/components/common/logo/Logo.js